import { IconButton, Stack, Typography, Theme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import dayjs from '../../../../config/dayjs';
import { StationDetailCardProps } from './types';
import DirectionIcon from '../../../../assets/icons/directionIcon.svg?react';
import { StyledGreenSpan } from '../../StyledGreenSpan/StyledGreenSpan';

export const StationDetailCard: React.FC<StationDetailCardProps> = ({
  data,
}) => {
  const { t } = useTranslation();
  const onButtonClick = () => {
    window.open(
      `https://www.google.com/maps/dir/?api=1&destination=${data?.longitude},${data?.latitude}&travelmode=driving`,
    );
  };

  const renderWorkingTimeSchedule = () => {
    if (data.aroundTheClock) {
      return t('maps.stationDetailCard.aroundTheClockText');
    } else {
      const startWorkingTime = dayjs(data.startWorkingTime).format('HH:mm');
      const endWorkingTime = dayjs(data.endWorkingTime).format('HH:mm');
      return `${startWorkingTime}:${endWorkingTime}`;
    }
  };
  return (
    <Stack
      sx={(theme: Theme) => ({
        gap: '15px',
        borderRadius: '15px',
        padding: '15px 7px',
        border: '1px solid',
        borderColor: theme.palette.gray[150],
      })}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="body1" color="common.white">
          {t('orderPage.pricing')}:{' '}
          <StyledGreenSpan>
            {data.price} ₴/{t('orderPage.energyUnit')}
          </StyledGreenSpan>
        </Typography>
        <IconButton
          id="basic-button"
          onClick={onButtonClick}
          sx={(theme: Theme) => ({
            padding: '4px 16px',
            backgroundColor: theme.palette.green.main,
            borderRadius: '6px',
            display: 'flex',
            gap: '6px',
            '&.MuiButtonBase-root.MuiIconButton-root:hover': {
              backgroundColor: theme.palette.green.main,
            },
          })}
        >
          <DirectionIcon width={14} />{' '}
          <Typography variant="body1" color="common.black">
            {t('maps.stationDetailCard.routeText')}
          </Typography>
        </IconButton>
      </Stack>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="body1" color="common.white">
          {t('maps.stationDetailCard.workScheduleText')}:{' '}
          {renderWorkingTimeSchedule()}
        </Typography>
      </Stack>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="body1" color="common.white">
          {t('orderPage.status')}: {t(`statuses.station.${data.status}`)}
        </Typography>
      </Stack>
    </Stack>
  );
};
